import { render, staticRenderFns } from "./PrivacypolicyPage.vue?vue&type=template&id=438a5f48&scoped=true"
import script from "./PrivacypolicyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacypolicyPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrivacypolicyPage.vue?vue&type=style&index=0&id=438a5f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a5f48",
  null
  
)

export default component.exports